import { useMemo, useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles, fontPalette } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

import RadioGroup from 'react-native-radio-buttons-group';

const CAinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params


  const options2 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]






  const options1 = [
    { key: 1, value: 'Single or Married (with two or more incomes)' },
    { key: 2, value: 'Married (one income)' },
    { key: 3, value: 'Head of Household' }
  ]





  const intialValues = {
    filingStatus: "",
    noOfRegularAllowances: "",
    noOfEstimatedDeductions: "",
    totalAllowances: '',
    additionalAmount: '',
    exempt: null,
    typeofexemption: ""

  }
  const alschema = yup.object({
    filingStatus: yup
      .string()
      .required('Filing Status is a required field'),
    // exempt: yup.string().required("Exempt from Withholding is a required field"),
    noOfRegularAllowances: yup
      .string()
      .nullable()
    // .when("exempt", (exempt: any, schema) => {
    //   if (exempt == 0) {
    //     return schema.required('No of Regular Allowances is a required field');
    //   }
    // return schema.nullable();
    // })
    ,

    noOfEstimatedDeductions: yup
      .string()
      .nullable()
    // .when("exempt", (exempt: any, schema) => {
    //   if (exempt == 0) {
    //     return schema.required('Claiming Head of Family is a required field');
    //   }
    //   return schema.nullable();
    // }),
    ,

    additionalAmount: yup
      .number()
      .typeError('Please enter numeric values')
      .nullable(),
    // .when("exempt", (exempt: any, schema) => {
    //   if (exempt == 0) {
    //     return schema.required('Additional amount is a required field');
    //   }
    //   return schema.nullable();
    // }),

    typeofexemption: yup.string().nullable()
    // .when("exempt", (exempt: any, schema) => {
    //   if (exempt == 1) {
    //     return schema.required("Type of Exemption is a required field")
    //   }
    //   return schema.nullable();
    // }),
  })
  const { loading, postcaonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const radioButtons = useMemo(() => ([
    {
      id: '1',
      label: 'I claim exemption from withholding for 2026, and I certify I meet both of the conditions for exemption.',
      value: '1',
      color: '#0B495C'
    },
    {
      id: '2',
      label: 'I certify under penalty of perjury that I am not subject to California withholding.I meet the conditions set forth under the Service Member Civil Relief Act, as amended by the Military Spouses Residency Relief Act and the Veterans Benefits and Transition Act of 2018',
      value: '2',
      color: '#0B495C',
    }
  ]), []);

  // useEffect(() => {
  //   getmodetails(initializestore?.initializeData?.userkey)
  // }, [])



  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'CA Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            const data = {
              completeOnline: mode === 'upload' ? false : true,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              filingStatus: values?.filingStatus ? values?.filingStatus : null,
              noOfReguralAllowances: values?.noOfRegularAllowances ? values?.noOfRegularAllowances : null,
              noOfEstimatedDeductions: values?.noOfEstimatedDeductions ? values?.noOfEstimatedDeductions : null,
              totalAllowances: Number(values?.noOfRegularAllowances) + Number(values?.noOfEstimatedDeductions),
              additionalAmount: values?.additionalAmount ? values?.additionalAmount : null,
              typeOfCertify: values?.typeofexemption ? values?.typeofexemption : null
            }

            const response = await postcaonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('CAInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            }
            else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={
                        props.values.filingStatus === 'Single'
                          ? 'Single or Married (with two or more incomes)'
                          : props.values.filingStatus === 'Married'
                            ? 'Married (one income)'
                            : props.values.filingStatus === 'Head of Household'
                              ? 'Head of Household'
                              : ''
                      }
                      onSelect={(option: any) => {
                        if (option == 1) {
                          props.setFieldValue('filingStatus', "Single")

                        }
                        else if (option == 2) {
                          props.setFieldValue('filingStatus', "Married")
                        }
                        else {
                          props.setFieldValue('filingStatus', "Head of Household")

                        }

                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus}
                        </Text>
                      )}
                  </View>
                </View>

                {/* {props.values.exempt != null && props.values.exempt == 0 && <> */}
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '50%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Number of Regular Withholding Allowances'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.noOfRegularAllowances}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('noOfRegularAllowances')(text)
                        }
                      }}
                    />
                    {props.touched.noOfRegularAllowances && props.errors.noOfRegularAllowances && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.noOfRegularAllowances}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '50%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Number of allowances from the Estimated Deductions'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.noOfEstimatedDeductions}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('noOfEstimatedDeductions')(text)
                        }
                      }}
                    />
                    {props.touched.noOfEstimatedDeductions && props.errors.noOfEstimatedDeductions && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.noOfEstimatedDeductions}
                      </Text>
                    )}
                  </View>
                </View>





                <RadioGroup
                  radioButtons={radioButtons}
                  onPress={(option: any) => {
                    props.setFieldValue("typeofexemption", option)
                    if (option === '1' || option === '2') {
                      props.setFieldValue("additionalAmount", "")
                    }
                  }}
                  selectedId={props.values.typeofexemption}
                  labelStyle={{ color: "#0B495C", fontSize: 14, fontFamily: fontPalette.primaryRegular }}
                  containerStyle={{ padding: 10, flexDirection: 'column', alignItems: 'flex-start' }}
                />
                {props.touched.typeofexemption &&
                  props.errors.typeofexemption && (
                    <Text style={globalStyles.dangerAlert}>
                      {props.errors.typeofexemption}
                    </Text>
                  )}


                {(props.values?.typeofexemption === '' || props.values?.typeofexemption == null) &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '50%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Additional amount, if any, you want withheld each pay period'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalAmount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalAmount')(text)
                          }
                        }}
                      />
                      {props.touched.additionalAmount && props.errors.additionalAmount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalAmount}
                        </Text>
                      )}
                    </View>
                  </View>
                }
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>

            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default CAinformationForm
